// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Shipments_establishments__1iUJf","header":"Shipments_header__1IdZM","tableHeader":"Shipments_tableHeader__2obLQ"};